import { render } from "./SocutnoLogo.vue?vue&type=template&id=603d74f2&scoped=true&ts=true"
import script from "./SocutnoLogo.vue?vue&type=script&lang=ts"
export * from "./SocutnoLogo.vue?vue&type=script&lang=ts"

import "./SocutnoLogo.vue?vue&type=style&index=0&id=603d74f2&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603d74f2"]])

export default __exports__